var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fee-lab-evolucao az-card-bordered rounded-sm" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-center justify-space-between flex-wrap az-gap-small mb-1"
        },
        [
          _c("div", [
            _c(
              "h3",
              { staticClass: "az-text-primary az-size-14 font-semibold" },
              [_vm._v(" Evolução do patrimônio · ciclo de vida ")]
            ),
            _c("p", { staticClass: "az-text-small ma-0 mt-1" }, [
              _vm._v(_vm._s(_vm.subtitulo))
            ])
          ]),
          _c("div", { staticClass: "fee-lab-evolucao__delta" }, [
            _c("span", { staticClass: "az-text-small" }, [
              _vm._v("Δ patrimônio aos " + _vm._s(_vm.idadeFinal) + " anos")
            ]),
            _c(
              "span",
              {
                staticClass: "az-title-secondary",
                style: _vm.toneStyles[_vm.deltaTone]
              },
              [_vm._v(" " + _vm._s(_vm.deltaLabel) + " ")]
            )
          ])
        ]
      ),
      _vm.hasData
        ? _c(
            "div",
            { staticClass: "fee-lab-evolucao__canvas mt-4" },
            [
              _c("line-chart", {
                attrs: {
                  "chart-data": _vm.chartDataset,
                  options: _vm.chartOptions,
                  styles: _vm.chartStyles
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "fee-lab-evolucao__kpis mt-4" },
        _vm._l(_vm.kpis, function(kpi) {
          return _c(
            "div",
            {
              key: kpi.key,
              staticClass:
                "fee-lab-evolucao__kpi az-card-bordered rounded-sm az-gap-xsmall"
            },
            [
              _c("span", { staticClass: "az-text-small" }, [
                _vm._v(_vm._s(kpi.label))
              ]),
              _c("span", { staticClass: "az-title-secondary" }, [
                _vm._v(_vm._s(kpi.value))
              ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }